// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__vNH2f","container-full":"styles_container-full__mRlsN","headline":"styles_headline__ICoWu"};